import { NavLink } from "react-router-dom";
import { Users, CalendarRange } from "lucide-react";
import { useUser } from "../../context/UserContext";

// Onglets « Gestion établissement » du chef (vues sans idclasse). Même habillage
// que PilotageCoordoTabs. AUTO-MASQUÉ hors chef. Aucune prop : tout est lu depuis
// les contexts, pour une insertion en une ligne dans le layout de routes (App.js).
function GestionChefTabs() {
    const { user } = useUser();
    if (user?.role !== "chef") return null;

    const onglets = [
        { label: "Gestion des professeurs", to: "/home/professeur_gestion/", icone: Users },
        { label: "Périodes scolaires", to: "/home/periode_scolaire/", icone: CalendarRange },
    ];

    return (
        <div className="px-4 pt-4">
            <div className="inline-flex flex-wrap gap-1 bg-white rounded-xl border border-slate-200 shadow-sm p-1">
                {onglets.map(({ label, to, icone: Icone }) => (
                    <NavLink
                        key={to}
                        to={to}
                        className={({ isActive }) =>
                            `flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-[13px] font-medium transition-colors duration-200 ${
                                isActive
                                    ? 'bg-gradient-to-br from-blue-500 to-cyan-500 text-white shadow-md shadow-blue-500/30'
                                    : 'text-slate-600 hover:text-slate-900 hover:bg-slate-50'
                            }`
                        }
                    >
                        <Icone className="w-4 h-4" />
                        {label}
                    </NavLink>
                ))}
            </div>
        </div>
    );
}

export default GestionChefTabs;
